import { Link } from 'react-router-dom';
import { categoryInfos } from '@/mocks/exposes';

export default function CategorySection() {
  return (
    <section className="bg-background-50" aria-labelledby="category-title">
      <div className="container-page py-12 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">栏目分类</p>
            <h2 id="category-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              按你关心的领域找料
            </h2>
          </div>
          <Link
            to="/ranking"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            进入完整榜单
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categoryInfos.map((cat) => (
            <Link
              key={cat.slug}
              to={`/ranking?category=${cat.slug}`}
              className="group flex flex-col rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className="flex w-11 h-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-xl">
                <i className={cat.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-500">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center justify-between text-xs text-foreground-500">
                <span>{cat.count} 条核实中</span>
                <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}